import React from "react";
import CaseStudyTemplatePage from "components/CaseStudyTemplate/CaseStudyTemplate";

import { useTranslation } from "react-i18next";

import imgBanner from "assets/images/pages/fe-banner.jpg";
import imgIdeas2 from "assets/images/pages/financial-engine/fe_ideas2.jpg";
import imgIdeas1 from "assets/images/pages/financial-engine/fe-ideas1.png";
import imgResult1 from "assets/images/pages/financial-engine/fe-result1.png";
import imgResult2 from "assets/images/pages/financial-engine/fe-result2.jpg";
import imgResult3 from "assets/images/pages/financial-engine/fe-result3.jpg";
import imgResult4 from "assets/images/pages/financial-engine/fe-result4.jpg";
import imgResult5 from "assets/images/pages/financial-engine/fe-result5.jpg";
import imgPersion1 from "assets/images/pages/home/clients/GBI-Peter Custer.jpg";
import imgBusiness1 from "assets/images/pages/home/clients/gbi_logo.png";
import { PAGES } from "constants/pages";

const CaseStudyFinancialEnginePage = () => {
  const { t } = useTranslation();
  document.title = t(PAGES.CASE_STUDY_FINANCIAL_ENGINE.title);

  const data = {
    banner: {
      header: "caseStudies.financialEngine.banner.header",
      text: "caseStudies.financialEngine.banner.text",
      badges: t("caseStudies.financialEngine.banner.badges", {
        returnObjects: true,
      }),
      image: imgBanner,
    },
    stats: t("caseStudies.financialEngine.stats", { returnObjects: true }),
    description: {
      header: "caseStudies.financialEngine.description.header",
      pargarafs: [
        {
          image: imgIdeas1,
          text: "caseStudies.financialEngine.description.paragrafs.paragraf1",
        },
        {
          image: imgIdeas2,
          text: "caseStudies.financialEngine.description.paragrafs.paragraf2",
        },
      ],
    },
    businessChallenges: t("caseStudies.financialEngine.businessChallenges", {
      returnObjects: true,
    }),
    ourSolutions: t("caseStudies.financialEngine.ourSolutions", {
      returnObjects: true,
    }),
    sthForOur: {
      header: "caseStudies.inspectMaster.sthForOur.header",
      client: {
        personName: t("homePage.paragraf5.items.item1.persion.name"),
        personPosition: t("homePage.paragraf5.items.item1.persion.position"),
        message: t("homePage.paragraf5.items.item1.text"),
        personImg: imgPersion1,
        businessImg: imgBusiness1,
        businessImgHeight: "55px",
        businessImgHeightSm: "35px",
      },
    },
    theResults: {
      header: "caseStudies.financialEngine.theResults.header",
      content: [
        {
          header: t(
            "caseStudies.financialEngine.theResults.results.result1.text"
          ),
          image: imgResult1,
          bgColor: "white",
        },
        {
          header: t(
            "caseStudies.financialEngine.theResults.results.result2.text"
          ),
          image: imgResult2,
          bgColor: "softBlue",
        },
        {
          header: t(
            "caseStudies.financialEngine.theResults.results.result3.text"
          ),
          image: imgResult3,
          bgColor: "thertiary",
        },
        {
          header: t(
            "caseStudies.financialEngine.theResults.results.result4.text"
          ),
          bgColor: "thertiary",
          image: imgResult4,
        },
        {
          header: t(
            "caseStudies.financialEngine.theResults.results.result5.text"
          ),
          bgColor: "softBlue",
          image: imgResult5,
        },
      ],
    },
    moreStories: {
      title: t("caseStudies.financialEngine.moreStories.header"),
      stories: t("caseStudies.financialEngine.moreStories.stories", {
        returnObjects: true,
      }),
    },
  };
  return <CaseStudyTemplatePage data={data} />;
};

export default CaseStudyFinancialEnginePage;
